import React, { useEffect, useMemo, useState } from "react";

import TrainingRecommendationModal from "./TrainingRecommendationModal";

import { useForm } from "react-hook-form";

import {
  getAllTrainingName,
  getTrainingRecommendationList,
} from "../../services/TrainingServices";
import { EditIcon, ViewIcon } from "../../../assets/CommonAssets";
import CommonHeading from "../../../common/components/Custom Hooks/CommonHeading";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import CommonTransactionPaginationTable from "../../../common/components/CommonTable/CommonTransactionPaginationTable";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";

/****************** user actions configuration ******************/
const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

const TrainingRecommendation = () => {
  const [TrainingRecommendationModalOpen, setTrainingRecommendationModalOpen] =
    useState(false);
  // const [TrainingRecommendationData, setTrainingRecommendationData] = useState(records);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [TrainingRecommendationList, setTrainingRecommendationList] = useState(
    [],
  );
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);

  const [
    TrainingRecommendationNameOptions,
    setTrainingRecommendationNameOptions,
  ] = useState([]);
  const [count, setCount] = useState(0);
  const [listingObject, setListingObject] = useState({
    searchString: "",
    page: page,
    size: rowsPerPage,
    searchId: null,
    menuId: null,
  });
  const { control, watch } = useForm();
  const watchTraining =
    watch("SearchableSelect")?.id || watch("SearchableSelect")?.value;
  /****************** form handling functions ******************/
  const populateTable = (forPagination) => {
    let tempObj = { ...listingObject, page: !forPagination ? 0 : page };

    showSpinner(true);
    getTrainingRecommendationList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 204) {
          if (forPagination) {
            setTrainingRecommendationList((prevData) => [
              ...prevData,
              ...res.result,
            ]);
          } else {
            setTrainingRecommendationList(res.result);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);

  //     if (selectedRow !== null) {
  //       deleteTrainingRecommendation(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           console.log("aaaaaaaaaaa", res);
  //           successAlert(res.message);
  //           // setPage(0)
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setTrainingRecommendationModalOpen(false);
  //           setSelectedRow(null);

  //         });
  //     }
  //   };
  //   useEffect(() => {
  //     populateTable();
  //   }, []);
  /****************** renderActions function ******************/
  //  {actions.isAction === true ? (
  //           <>
  //             <div className="flex gap-2 cursor-pointer">
  //               {actions.permission === "Edit" ? (
  //                 <RescheduleIcon
  //                   title={"Schedule"}
  //                   type={"button"}
  //                   sx={{ color: "gray" }}
  //                   onClick={() => {
  //                     setSelectedRow({ ...row, editType: "Schedule" });

  //                     setTrainingRecommendationModalOpen(true);
  //                   }}
  //                 />
  //               ) : null}
  //             </div>
  //           </>
  //         ) : null}
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-1 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Edit" ? (
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedRow({ ...row, editType: "Edit" });

                        setTrainingRecommendationModalOpen(true);
                      }}
                    >
                      <EditIcon
                        title={"Edit"}
                        type={"button"}
                        sx={{ color: "#D11A2A" }}

                        // onClick={() => deleteRow(row)}
                      />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Edit" ? (
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedRow({ ...row, editType: "View" });

                        setTrainingRecommendationModalOpen(true);
                      }}
                    >
                      <ViewIcon
                        title={"View Info"}
                        type={"button"}
                        sx={{ color: "#D11A2A" }}

                        // onClick={() => deleteRow(row)}
                      />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  /****************** renderInput ********************/
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                   ${
                     row.Status
                       ? "text-customGreen border-customGreen"
                       : "text-customRed border-customRed"
                   }`}
            type="button"
          >
            {row.Status ? "Active" : "Inactive"}
          </button>
        )}
      </>
    );
  };

  useEffect(() => {
    populateTable();
  }, [listingObject.searchId, listingObject.searchString]);
  return (
    <div className="px-2 my-1">
      {CommonHeading("Training Recommendations")}

      <div className="flex gap-2 w-full items-center mt-2">
        <div className="flex w-full gap-2 items-center">
          <div className="grid w-[50%] grid-cols-1 gap-2">
            <div className="">
              <SearchDropdown
                control={control}
                name="SearchableSelect"
                placeholder="Search by Training*"
                isSearchable={true}
                dataArray={trainingNameOptions}
                searchIcon={true}
                handleInputChange={(e) => {
                  const tempCheckChar =
                    e !== null ? UseCheckConsecutiveCharacters(e) : true;
                  if (e !== "" && tempCheckChar) {
                    getAllTrainingName(e)
                      .then((response) => {
                        setTrainingNameOptions(response.data.result);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    setTrainingNameOptions([]);
                  }
                }}
                onChange={(e) => {
                  if (e !== "") {
                    setSearchString(e);
                  } else {
                    setSearchString(null);
                  }
                }}
                isClearable={true}
                // error={errors?.training}
              />
            </div>
          </div>
          <div>
            <CommonButton
              className="bg-customBlue text-white"
              searchIcon={true}
              onClick={() => {
                setListingObject({
                  searchString: watch("SearchableSelect")?.label || "",
                  page: page,
                  size: rowsPerPage,
                  searchId: watch("SearchableSelect")
                    ? watch("SearchableSelect")?.id
                    : null,
                  menuId: null,
                });
              }}
            />
          </div>
        </div>
        <div className="grid justify-end xl:col-span-3 w-1/3">
          {userActions &&
            userActions.map((obj) => (
              <>
                {!obj.isAction && obj.permission === "Create" ? (
                  <CommonButton
                    onClick={() => setTrainingRecommendationModalOpen(true)}
                    label="+ New"
                    className="modalButton bg-customBlue text-white"
                  />
                ) : null}
              </>
            ))}
        </div>
      </div>
      {spinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}

      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      <TrainingRecommendationModal
        setTrainingRecommendationModalOpen={setTrainingRecommendationModalOpen}
        TrainingRecommendationModalOpen={TrainingRecommendationModalOpen}
        // setTrainingRecommendationData={setTrainingRecommendationData}
        // TrainingRecommendationData={TrainingRecommendationData}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        populateTable={populateTable}
        openBackDrop={openBackDrop}
        setOpenBackdrop={setOpenBackdrop}
        setTrainingRecommendationList={setTrainingRecommendationList}
        TrainingRecommendationList={TrainingRecommendationList}
      />
      <div>
        {TrainingRecommendationList?.length > 0 && !spinner ? (
          <CommonTransactionPaginationTable
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            // populateTable={populateTable}
            count={TrainingRecommendationList?.length}
            highlightRow={false}
            dataResult={TrainingRecommendationList}
            renderActions={renderActions}
            renderInput={renderInput}
            editableColumns={"Status"}
            removeHeaders={[
              "id",
              "TrainingId",
              "Id",
              "Employee Name",
              "trainingId",
            ]}
            tableClass="capitalize"
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                  No Records Found...
                </h3>
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmationModal
        confirmationOpen={openDeleteModal}
        confirmationHandleClose={() => {
          setOpenDeleteModal(false);
          setSelectedRow(null);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to delete this record?"
        confirmationSubmitFunc={() => {}}
        confirmationButtonMsg="Delete"
      />
    </div>
  );
};

export default TrainingRecommendation;
